import { types } from "../types/types";

const INITIAL_STATE = {
  products: null,
};

const productsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.addProducts:
      return {
        ...state,
        products: action.payload,
      };
    case types.removeCauses:
      return {
        ...state,
        products: null,
      };
    default:
      return state;
  }
};

export default productsReducer;
